/* eslint-disable jsx-a11y/alt-text */

import Optimization from "../assets/images/Bulut8.jpg";

const Performance = () => {
  return (
    <>
      {/* main1 */}
      <main className="container max-w-7xl mx-auto mt-12 py-2 ">
        {/* img and title */}
        <div className=" rounded border-l-8 border-teal-700 bg-[#a4d6d6] flex justify-center items-center flex-col sm:flex-row">
          <div>
            <img src={Optimization} className="opacity-[0.8]  max-h-80" />
          </div>

          <div className=" text-left m-10">
            <h2 className=" text-4xl sm:text-5xl font-bold font-sans text-zinc-700 mb-4  ">
              PERFORMANCE OPTIMISATION
            </h2>
            <p className="text-4xl sm:text-5xl text-teal-800  font-sans font-bold opacity-[]">
              Boost Your System's Capability
            </p>
          </div>
        </div>
        {/* <div className="bg-orange-500 h-1"></div> */}
      </main>
      {/* main2 */}
      <main className="bg-white  ">
        <main className="container max-w-7xl  bg-white  mx-auto px-2 py-2 ">
          {/* section1 */}
          <section className=" text-lg font-bold text-gray-600 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-8 mt-4">
            <div className="p-4 rounded-lg">
              <div className="flex justify-center items-center" />

              {/* <img src={Push} className="max-w-full h-auto" /> */}
              <h3 className="text-2xl font-bold  text-teal-500 mb-4">
                ENSURE PEAK PERFORMANCE
              </h3>
              <p>
                In our digital age, optimal infrastructure is critical. With
                Cloudifiers' guidance and AWS's cutting-edge resources, we
                ensure your platform not only meets today's needs but is primed
                for future challenges.
              </p>
            </div>
            <div className="p-4 rounded-lg">
              <h3 className="text-2xl font-bold text-teal-500 mb-4">
                PERFORMANCE OBJECTIVES
              </h3>
              <p>
                Aim high, satisfy more. We aid in setting and achieving key
                performance goals-be it reducing delays, increasing
                availability, or enhancing data flow-ensuring your
                infrastructure's peak operation aligns with client expectations.
              </p>
            </div>
            <div className="p-4 rounded-lg">
              <h3 className="text-2xl font-bold text-teal-500 mb-4">
                TECHNICAL ARCHITECTURE
              </h3>
              <p>
                Foundation for growth. We navigate you through selecting the
                best AWS resources and services, ensuring a robust and adaptable
                system poised for expansion.
              </p>
            </div>
            <div className="p-4 rounded-lg">
              <h3 className="text-2xl font-bold text-teal-500 mb-4">
                PERFORMANCE ANALYSIS
              </h3>
              <p>
                Monitor, refine, excel. Our continuous analysis pinpoints and
                resolves any inefficiencies, ensuring smooth operation and
                optimal user experience.
              </p>
            </div>
            <div className="p-4 rounded-lg">
              <h3 className="text-2xl font-bold text-teal-500 mb-4">
                STRATEGIC GROWTH PLANNING
              </h3>
              <p>
                Strategize for expansion. Our services evolve with your
                business, providing strategic insights and stress tests to
                prepare your platform for scaling up without performance loss.
              </p>
            </div>
            <div className="p-4 rounded-lg">
              <h3 className="text-2xl font-bold text-teal-500 mb-4">
                CONTINUOUS REVIEW
              </h3>
              <p>
                Stay current and competitive. We proactively refine your system
                within AWS's dynamic ecosystem, keeping your operations at peak
                efficiency.
              </p>
            </div>
          </section>
        </main>
      </main>

      {/* main3 */}
      <main className="mt-14 mb-14 opacity-[0.9]">
        <main className="container max-w-7xl mx-auto bg-gray-100 text-xl text-gray-700 font-bold px-4 py-2 mb-2 rounded-lg border">
          {/* <div className=" h-2"></div>
          <hr className="border-[#36b6abee] border-[1.5px] dark:border-gray-700 "></hr> */}
          <div className="text-center ">
            <h2 className="text-5xl font-bold text-zinc-700  mb-8 mt-8">
              FEATURED SERVICES
            </h2>
            <p className="font-bold font-sans text-4xl  text-teal-800 mt-4 mb-4 opacity-[0.9]">
              Your Pathway to Enhanced Efficiency and Scalability
            </p>
            <p className="font-bold font-sans text-2xl text-zinc-700 mt-4 mb-8 ">
              Discover how Cloudifiers can help you optimize the performance{" "}
              <br /> of your infrastructure and future-proof your platform for
              years to come.
            </p>
          </div>
          <section className=" text-lg font-bold grid text-zinc-700 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 ">
              <div className="flex justify-center items-center" />
              <svg
                className="h-32 w-40 text-zinc-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                />
              </svg>
              <br />
              <h3 className="text-2xl font-bold text-zinc-700  mb-4">
                PERFORMANCE OPTIMISATION SERVICES
              </h3>
              <p>
                Power up your infrastructure. Our bespoke services enhance
                efficiency and reliability, supporting your immediate needs and
                future expansion.
              </p>
              <a
                href="#"
                className="inline-block mt-8 bg-zinc-700 hover:bg-teal-600 text-white font-bold py-2 px-4 rounded"
              >
                Learn More
              </a>
            </div>
            <div className="p-6 rounded-lg">
              <svg
                className="h-32 w-40 text-zinc-600"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {" "}
                <polygon points="12 2 2 7 12 12 22 7 12 2" />{" "}
                <polyline points="2 17 12 22 22 17" />{" "}
                <polyline points="2 12 12 17 22 12" />
              </svg>
              <br />
              <h3 className="text-2xl font-bold text-zinc-700  mb-4">
                AWS WELL-ARCHITECTED REVIEW
              </h3>
              <p>
                In-depth insights for a solid foundation. Our AWS
                Well-Architected Review uncovers opportunities to save costs and
                bolster your system’s architecture.
              </p>
              <a
                href="#"
                className="inline-block mt-8  bg-zinc-700 hover:bg-teal-600 text-white font-bold py-2 px-4 rounded"
              >
                Learn More
              </a>
            </div>

            <div className="p-6 rounded-lg">
              <svg
                className="h-32 w-40 text-zinc-600"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {" "}
                <path stroke="none" d="M0 0h24v24H0z" />{" "}
                <path d="M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />{" "}
                <path d="M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2" />
              </svg>
              <br />
              <h3 className="text-2xl font-bold text-zinc-700  mb-4">
                PROACTIVE SUPPORT
              </h3>
              <p>
                Always ahead. With our continuous support, your platform
                operates flawlessly, ensuring you stay competitive and
                responsive to market dynamics.
              </p>
              <a
                href="#"
                className="inline-block mt-16 bg-zinc-700  hover:bg-teal-600 text-white font-bold py-2 px-4 rounded"
              >
                Learn More
              </a>
            </div>
          </section>
          {/* <hr className="border-[#36b6abee] border-[1.5px] dark:border-gray-700 "></hr>
          <div className="bg-zinc-100   h-1"></div> */}
        </main>
      </main>
    </>
  );
};

export default Performance;
